import type { Item } from '@/components/SelectFieldComp';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { ABSENCE_REASON_DETAIL_INFECTION_TYPE, type AbsenceReasonDetailInfectionType } from '@/types/domain/attendContact/valueObjects/absenceReasonDetailInfection';

/**
 * 感染症理由
 */
export class AbsenceReasonDetailInfection extends PrimitiveValueObject<
  AbsenceReasonDetailInfectionType
> {
  /**
   * 作成
   * @param props プロパティ
   * @returns 結果
   */
  static create(props: AbsenceReasonDetailInfectionType): AbsenceReasonDetailInfection {
    return new AbsenceReasonDetailInfection(props);
  }

  /** ラベル */
  static get label(): string {
    return '詳細';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /**
   * アイテムリスト
   */
  static get items(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items: Item[] = [];
    for (let i = 0; i < ABSENCE_REASON_DETAIL_INFECTION_TYPE.length; i += 1) {
      items.push({
        id: ABSENCE_REASON_DETAIL_INFECTION_TYPE[i],
        name: ABSENCE_REASON_DETAIL_INFECTION_TYPE[i],
      });
    }
    return items;
  }
}
